/**
 * The room's standing on a juurisyy, for drawing it (specs/systemic-map-v2-room-review.md §2).
 *
 * No thresholds decide anything: the votes give an approval %, which orders the
 * facilitator's discussion and colours the card on a continuous scale. What
 * removes a card is the discussion's explicit rejection, and the lock.
 */

/**
 * Approval % from the verdict tally. A refine counts as a vote that is not an
 * approval: it says "not as written". No votes is `null`, not 0 % — an unjudged
 * card and a card everyone rejected must not look alike.
 * @returns {{ pct: number, votes: number } | null}
 */
export function approvalOf(verdicts) {
  const approve = verdicts?.approve || 0;
  const votes = approve + (verdicts?.reject || 0) + (verdicts?.refine || 0);
  if (!votes) return null;
  return { pct: Math.round((approve / votes) * 100), votes };
}

/** "74 % · 19 ääntä" style label; `noVotes` when there are none. */
export function approvalLabel(verdicts, t) {
  const a = approvalOf(verdicts);
  if (!a) return t('systemicMapV2.review.noVotes');
  return t('systemicMapV2.review.approval', { pct: a.pct, votes: a.votes });
}

/**
 * The earlier versions' standing, as the record: "v1: 1/3 hyväksyi, tarkennettu".
 * A refined card's approval is its current version's only; '' with no earlier votes.
 */
export function earlierLabel(earlier, t) {
  return (earlier || []).filter((e) => e.approval)
    .map((e) => t('systemicMapV2.review.earlierVersion', { version: e.version, approve: e.verdicts.approve || 0, votes: e.approval.votes }))
    .join(' · ');
}

/**
 * Fill for an open card: a continuous red → amber → green by approval, grey
 * with no votes. Continuous on purpose — a colour band would be a threshold.
 */
export function approvalFill(verdicts) {
  const a = approvalOf(verdicts);
  if (!a) return 'rgba(255,255,255,0.28)';
  const p = a.pct / 100;
  // 0 → hsl(0), 0.5 → hsl(40), 1 → hsl(140)
  const hue = p < 0.5 ? p * 2 * 40 : 40 + (p - 0.5) * 2 * 100;
  return `hsla(${Math.round(hue)}, 62%, 62%, 0.9)`;
}
